import { createClient, ClientPerspective, SanityClient } from "@sanity/client";

import config from "../../config.default.mjs";

/**
 * Sanity client for querying published documents.
 */
const sanityClientPublished = createClient({
  useCdn: true,
  perspective: "published",
  dataset: config.services.sanity.dataset,
  token: config.services.sanity.viewerToken,
  projectId: config.services.sanity.projectId,
  apiVersion: config.services.sanity.apiVersion,
});

/**
 * Sanity client for querying published and draft documents.
 */
const sanityClientPreviewDrafts = createClient({
  useCdn: false,
  perspective: "previewDrafts",
  dataset: config.services.sanity.dataset,
  token: config.services.sanity.viewerToken,
  projectId: config.services.sanity.projectId,
  apiVersion: config.services.sanity.apiVersion,
});

/**
 * Resolve sanity client from given perspective.
 */
export function sanityFromPerspective(
  perspective: ClientPerspective,
): SanityClient {
  if ("published" === perspective) return sanityClientPublished;
  if ("previewDrafts" === perspective) return sanityClientPreviewDrafts;
  throw new Error(
    `Sanity client not resolvable for perspective ${perspective}.`,
  );
}

// Map the given array to an object with edges.
// This is used for interoperability as the old GraphQL queries come with edges and nodes, but GROQ results do not.
export function mapToEdges<T>(collection: T[]) {
  return {
    edges: collection.map((node) => ({ node })),
  };
}
